import { render, staticRenderFns } from "./btn-arrow-primary.vue?vue&type=template&id=95ceaeee&scoped=true"
import script from "./btn-arrow-primary.vue?vue&type=script&lang=js"
export * from "./btn-arrow-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ceaeee",
  null
  
)

export default component.exports